import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const configuration = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_FAILURE,
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_REQUEST,
    )]: () => ({}),
    [actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_SUCCESS]:
      (state, { payload }) => payload,
    [actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_SUCCESS]:
      (state, { payload }) => payload?.configuration,
  },
  {},
);

export const isLoading = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_SUCCESS,
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_FAILURE,
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_SUCCESS,
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_REQUEST,
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_REQUEST,
    )]: () => true,
  },
  false,
);

export const saveSuccess = handleActions(
  {
    [combineActions(
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_REQUEST,
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_FAILURE,
      actionTypes.RESET_CONFIGURATION_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_SUCCESS,
    )]: () => true,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_SUCCESS,
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_FAILURE,
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_SUCCESS,
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_REQUEST,
    )]: () => ({}),
    [combineActions(
      actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_FAILURE,
      actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);


export default combineReducers({
  configuration,
  isLoading,
  error,
  saveSuccess,
});
